import React, { useState, useEffect } from "react"
import { useQuery } from "@apollo/react-hooks"
import { gql } from "apollo-boost"
import { SelectButton, Loader, LegTypesWrapper } from "../StyledComponents"
import { ReactComponent as Check } from "../../svg/check.svg"
const LegTypes = ({ legType, setLegType, types }) => {
    return (
        <LegTypesWrapper>
            {types.map((type, i) => (
                <button
                    key={i}
                    className={type === legType ? "active" : undefined}
                    onClick={() => {
                        setLegType(type)
                    }}>
                    {type}
                </button>
            ))}
        </LegTypesWrapper>
    )
}

export const Legs = ({ selected, handleClick }) => {
    const [legType, setLegType] = useState(null)
    let sortedItems = null
    const { loading, error, data } = useQuery(
        gql`
            query legs($id: Int!) {
                bedType(id: $id) {
                    id
                    legs {
                        id
                        title
                        height
                        productThumbnail(version: "byob-textile") {
                            url
                            width
                            height
                        }
                        legType {
                            title
                            id
                        }
                    }
                }
            }
        `,
        { variables: { id: selected.bed.id } }
    )
    useEffect(() => {
        if (
            sortedItems !== null &&
            legType === null &&
            sortedItems.types.length > 0
        ) {
            setLegType(sortedItems.types[0])
        }
    }, [sortedItems, data, legType])
    if (loading) return <Loader />
    if (error) return <p>Error :(</p>
    const items = data.bedType.legs
    sortedItems = { types: [], items: [] }
    items.forEach((item) => {
        if (sortedItems.types.indexOf(item.legType.title) === -1) {
            sortedItems.types = [...sortedItems.types, item.legType.title]
        }

        if (!sortedItems.items[item.legType.title]) {
            sortedItems.items[item.legType.title] = []
        }
        sortedItems.items[item.legType.title] = [
            ...sortedItems.items[item.legType.title],
            item,
        ]
    })
    return (
        <>
            <LegTypes
                legType={legType}
                setLegType={setLegType}
                types={sortedItems.types}
            />
            {legType &&
                sortedItems.items[legType].map((item, i) => {
                    if (item.productThumbnail === null) {
                        return null
                    }
                    return (
                        <SelectButton
                            className={`${
                                selected.legs &&
                                parseInt(item.id) === selected.legs.id
                                    ? "active"
                                    : "inActive"
                            }`}
                            key={i}
                            onClick={() =>
                                handleClick({
                                    id: parseInt(item.id),
                                    height: parseInt(item.height),
                                    title: item.title,
                                    compat: parseInt(item.legType.id) !== 3,
                                })
                            }>
                            <img
                                loading="lazy"
                                src={item.productThumbnail.url}
                                alt=""
                                height="90"
                                width="90"
                            />
                            <h3>{item.title}</h3>
                            <Check />
                        </SelectButton>
                    )
                })}
        </>
    )
}
